import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { apiRequest } from '@/lib/auth';

// Team password reset (link from the reset email)
export default function ResetPassword() {
  const { token } = useParams();
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return toast.error('Choose a password with at least 8 characters');
    if (pw !== pw2) return toast.error('The passwords do not match');
    setBusy(true);
    try {
      await apiRequest('/api/auth/password-reset', { method: 'POST', body: JSON.stringify({ token, new_password: pw }) });
      setDone(true);
    } catch (err) {
      toast.error(err.message || 'That reset link has expired. Ask for a new one.');
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ backgroundColor: 'hsl(var(--background))', fontFamily: 'Manrope, sans-serif' }}>
      <div className="w-full max-w-sm rounded-xl border border-[#E3DDD1] bg-white p-6">
        <img src="/stagehead-os-lockup-light.svg" alt="Stagehead OS" style={{ height: 36, margin: '0 auto 1.25rem' }} />
        {done ? (
          <div className="text-center space-y-4">
            <p className="text-[#1E2A33]">Your password has been changed.</p>
            <Button className="w-full" style={{ backgroundColor: 'hsl(var(--accent))' }} onClick={() => { window.location.href = '/login'; }}>Sign in</Button>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <h1 className="text-xl font-semibold text-[#1E2A33] text-center" style={{ fontFamily: 'Fraunces, Georgia, serif' }}>Choose a new password</h1>
            <div className="space-y-2"><Label htmlFor="pw">New password</Label><Input id="pw" type="password" value={pw} onChange={(e) => setPw(e.target.value)} autoComplete="new-password" /></div>
            <div className="space-y-2"><Label htmlFor="pw2">Repeat it</Label><Input id="pw2" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} autoComplete="new-password" /></div>
            <Button type="submit" disabled={busy} className="w-full" style={{ backgroundColor: 'hsl(var(--accent))' }}>{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Save password'}</Button>
          </form>
        )}
      </div>
    </div>
  );
}
